import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureModulesService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { COMMON_CART_FEATURE } from '../constants';
import { CustomBrandService, HobStateService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class CartModuleGuard implements CanActivate {
  constructor(
    private featureModulesService: FeatureModulesService,
    private hobStateService: HobStateService,
    private customBrandService: CustomBrandService) {}

  canActivate(): Observable<boolean> {
    if (this.hobStateService.hobState.isHob) {
      this.customBrandService.setActive(this.hobStateService.hobState.siteBrand);
    }
    return this.featureModulesService.resolveFeature(COMMON_CART_FEATURE).pipe(map(() => true));
  }
}
